import axios from 'axios';

export class ApiProvider {
    static create(data = {}) {
        const self = new ApiProvider();
        const config = {
            data: JSON.stringify('es'),
            baseURL: data.baseUrl || API_BASE_URL, // eslint-disable-line
        };

        const provider = axios.create(config);

        provider.interceptors.response.use(
            (response) => response.data,
            (error) => self._handleError(error)
        );

        return provider;
    }

    /** @private */
    _handleError(error) {
        throw new Error(error, error.status);
    }
}
